import { useEffect } from 'react';
import { logoutThunk } from 'store/authentication/authentication.thunks';
import { closeMenu } from 'store/menu/menu.slice';
import { closeModal } from 'store/modals/modals.slice';
import { clearCurrentYearDataAction } from 'store/years/years.slice';

import { useAppDispatch, useAppSelector } from '../../../store';

export const LogoutPage = () => {
  const dispatch = useAppDispatch();
  const modals = useAppSelector((state) => state.modals);

  useEffect(() => {
    modals.forEach((modal) => {
      if (modal.isOpen) {
        dispatch(closeModal({ name: modal.name }));
      }
    });

    dispatch(logoutThunk());
    dispatch(clearCurrentYearDataAction());
    dispatch(closeMenu());
  }, [dispatch, modals]);

  return null;
};
